import type { Theme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';

/**
 * רק מה ש־CSS סטטי לא יכול לסנכרן דינמית עם ערכת MUI בלי קובץ אחרון:
 * נשען בעיקר על `scrollbar-chrome.css` (נטען אחרון ב-index) ל-WebKit.
 * כאן: Firefox scrollbar-color לפי theme + scrollbar-gutter.
 */
export function getGlobalScrollbarStyles(theme: Theme) {
  const isDark = theme.palette.mode === 'dark';
  const thumb = isDark ? alpha(theme.palette.common.white, 0.14) : alpha(theme.palette.common.black, 0.1);

  return {
    /**
     * מעטפת אפליקציה — גלילה בתוך אזורי תוכן (MainLayout / Outlet), לא על document.
     * מונע חריגה של כמה px (100vh מול 100dvh, scrollbar-gutter) שחוזרת ברוב הדפים.
     */
    html: {
      height: '100%',
      overflow: 'hidden',
      scrollbarGutter: 'stable',
    },
    body: {
      height: '100%',
      margin: 0,
      overflow: 'hidden',
      scrollbarWidth: 'thin',
      scrollbarColor: `${thumb} transparent`,
    },
    '#root': {
      height: '100%',
      minHeight: 0,
      overflow: 'hidden',
    },
    /** ילד ישיר (למשל ClerkProvider) — מאפשר height: 100% עד MainLayout */
    '#root > *': {
      height: '100%',
      minHeight: 0,
    },
  } as const;
}
